import React from 'react';
import { FormattedMessage } from 'react-intl';

interface Props {
    variant: 'first-run' | 'no-results';
    onClearFilters?: () => void;
    onCreate?: () => void;
}

const ArticleEmptyState: React.FC<Props> = ({ variant, onClearFilters, onCreate }) => {
    return (
        <div className="art-empty">
            <div className="art-empty__icon" aria-hidden="true">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                    <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
                    <line x1="12" y1="22.08" x2="12" y2="12" />
                </svg>
            </div>

            {variant === 'first-run' ? (
                <>
                    <h3 className="art-empty__title">
                        <FormattedMessage id="admin.articles.empty.firstRun.title" defaultMessage="Nuk keni shtuar ende artikuj" />
                    </h3>
                    <p className="art-empty__subtitle">
                        <FormattedMessage id="admin.articles.empty.firstRun.subtitle" defaultMessage="Filloni duke krijuar artikullin e parë të katalogut" />
                    </p>
                    {onCreate && (
                        <button type="button" className="art-btn art-btn--primary" onClick={onCreate}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M5 12h14M12 5v14" />
                            </svg>
                            <FormattedMessage id="admin.articles.empty.firstRun.cta" defaultMessage="Krijo artikullin e parë" />
                        </button>
                    )}
                </>
            ) : (
                <>
                    <h3 className="art-empty__title">
                        <FormattedMessage id="admin.articles.empty.noResults.title" defaultMessage="Asnjë artikull nuk u gjet" />
                    </h3>
                    <p className="art-empty__subtitle">
                        <FormattedMessage id="admin.articles.empty.noResults.subtitle" defaultMessage="Provoni të ndryshoni filtrat ose kërkimin" />
                    </p>
                    {onClearFilters && (
                        <button type="button" className="art-btn art-btn--ghost" onClick={onClearFilters}>
                            <FormattedMessage id="admin.articles.empty.noResults.cta" defaultMessage="Pastro filtrat" />
                        </button>
                    )}
                </>
            )}
        </div>
    );
};

export default ArticleEmptyState;
